/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'



export const logout = createAsyncThunk('user/logout', async (page, { rejectWithValue }) => {

    try { 
        window.localStorage.removeItem('getchkdjwt');
        return {}

    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const authenticate = createAsyncThunk('user/authenticate', async ({ username, password }, { rejectWithValue }) => {
    try { 
        const data = await api.user.login(username, password)


        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getUserInfo = createAsyncThunk('user/getUserMe', async (_, { rejectWithValue }) => {
    try {
 
        const data = await api.user.getUserMe();
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getUsersCount = createAsyncThunk('user/getUsersCount', async (_, { rejectWithValue }) => {
    try {
 
        const data = await api.user.getUsersCount();
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getUserById = createAsyncThunk('user/getUserById', async (userid, { rejectWithValue }) => {
    try {
 
        const data = await api.user.getUserById(userid);
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getUser = createAsyncThunk('user/getUser', async (user, { rejectWithValue }) => {
    try {
 
        const data = await api.user.getUser(user);
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getUserFiltred = createAsyncThunk('user/getUserFiltred', async (user, { rejectWithValue }) => {
    try {
 
        const data = await api.user.getUser(user);
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getUsersInfo = createAsyncThunk('user/getUsersInfo', async (_, { rejectWithValue }) => {
    try {
 
        const data = await api.user.getUsersInfo();
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllUsers = createAsyncThunk('user/getAllUsers', async (params, { rejectWithValue }) => {
    try {
 
        const data = await api.user.getAllUsers(params);
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
